import { render } from "./HubRelease.vue?vue&type=template&id=2f57e988"
const script = {}

import "./HubRelease.vue?vue&type=style&index=0&id=2f57e988&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__